var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container search" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "row flex-column-reverse flex-sm-row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 text-right" }, [
              _vm.$userIsAdmin() ||
              _vm.$canManageCompany(_vm.loggedInUser.company_id)
                ? _c(
                    "a",
                    {
                      staticClass: "link",
                      attrs: {
                        href: "/companies/" + _vm.loggedInUser.company_id
                      }
                    },
                    [_vm._v("To company user list")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$userIsAdmin()
                ? _c("a", { staticClass: "link", attrs: { href: "/users" } }, [
                    _vm._v("To user list")
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm.user
            ? _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.onSubmit.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("messages", { attrs: { messages: _vm.messages } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-9 container-search label-fixed user"
                      },
                      [
                        _c("div", { staticClass: "user-block" }, [
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Company",
                                    "label-for": _vm.getId("company_id"),
                                    state: _vm.fieldState("company_id"),
                                    "invalid-feedback": _vm.invalidField(
                                      "company_id"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      staticClass: "form-control",
                                      attrs: {
                                        id: _vm.getId("company_id"),
                                        disabled: !_vm.$userIsSuperAdmin()
                                      },
                                      model: {
                                        value: _vm.user.company_id,
                                        callback: function($$v) {
                                          _vm.$set(_vm.user, "company_id", $$v)
                                        },
                                        expression: "user.company_id"
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { domProps: { value: null } },
                                        [_vm._v("Select a company")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.companies, function(company) {
                                        return _c(
                                          "option",
                                          { domProps: { value: company.id } },
                                          [_vm._v(_vm._s(company.name))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "User Name / Login",
                                    "label-for": _vm.getId("qwerty"),
                                    state: _vm.fieldState("username"),
                                    "invalid-feedback": _vm.invalidField(
                                      "username"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: _vm.getId("qwerty"),
                                      type: "text",
                                      autocomplete: "off",
                                      state: _vm.fieldState("username"),
                                      placeholder: "Enter username"
                                    },
                                    model: {
                                      value: _vm.user.username,
                                      callback: function($$v) {
                                        _vm.$set(_vm.user, "username", $$v)
                                      },
                                      expression: "user.username"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "First Name",
                                    "label-for": _vm.getId("first_name"),
                                    state: _vm.fieldState("first_name"),
                                    "invalid-feedback": _vm.invalidField(
                                      "first_name"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: _vm.getId("first_name"),
                                      type: "text",
                                      state: _vm.fieldState("first_name"),
                                      placeholder: "Enter first name"
                                    },
                                    model: {
                                      value: _vm.user.first_name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.user, "first_name", $$v)
                                      },
                                      expression: "user.first_name"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Last Name",
                                    "label-for": _vm.getId("last_name"),
                                    state: _vm.fieldState("last_name"),
                                    "invalid-feedback": _vm.invalidField(
                                      "last_name"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: _vm.getId("last_name"),
                                      type: "text",
                                      state: _vm.fieldState("last_name"),
                                      placeholder: "Enter last name"
                                    },
                                    model: {
                                      value: _vm.user.last_name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.user, "last_name", $$v)
                                      },
                                      expression: "user.last_name"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Email",
                                    "label-for": _vm.getId("email"),
                                    state: _vm.fieldState("email"),
                                    "invalid-feedback": _vm.invalidField(
                                      "email"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: _vm.getId("email"),
                                      type: "text",
                                      state: _vm.fieldState("email"),
                                      placeholder: "Enter email"
                                    },
                                    model: {
                                      value: _vm.user.email,
                                      callback: function($$v) {
                                        _vm.$set(_vm.user, "email", $$v)
                                      },
                                      expression: "user.email"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Secondary Email",
                                    "label-for": _vm.getId("secondary_email"),
                                    state: _vm.fieldState("secondary_email"),
                                    "invalid-feedback": _vm.invalidField(
                                      "secondary_email"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: _vm.getId("secondary_email"),
                                      type: "text",
                                      state: _vm.fieldState("secondary_email"),
                                      placeholder: "Enter Secondary Email"
                                    },
                                    model: {
                                      value: _vm.user.secondary_email,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.user,
                                          "secondary_email",
                                          $$v
                                        )
                                      },
                                      expression: "user.secondary_email"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Bid Email User",
                                    title:
                                      "Only bid notifications will be sent here",
                                    "label-for": _vm.getId(
                                      "bid_notification_user_id"
                                    ),
                                    state: _vm.fieldState(
                                      "bid_notification_user_id"
                                    ),
                                    "invalid-feedback": _vm.invalidField(
                                      "bid_notification_user_id"
                                    )
                                  }
                                },
                                [
                                  _c("user-selector", {
                                    attrs: {
                                      placeholder: "-",
                                      "allow-empty": true,
                                      "names-first": true,
                                      "include-me": true,
                                      "include-dealers": false,
                                      "include-admins": true
                                    },
                                    model: {
                                      value: _vm.user.bid_notification_user_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.user,
                                          "bid_notification_user_id",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "user.bid_notification_user_id"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    title: "Used in Motorcentral",
                                    label: "Owner Key",
                                    "label-for": _vm.getId("Motor Central Key"),
                                    state: _vm.fieldState("ownerkey"),
                                    "invalid-feedback": _vm.invalidField(
                                      "ownerkey"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      disabled: !_vm.$userIsSuperAdmin(),
                                      id: _vm.getId("ownerkey"),
                                      type: "text",
                                      state: _vm.fieldState("ownerkey"),
                                      readonly: "",
                                      placeholder: "Ownerkey"
                                    },
                                    model: {
                                      value: _vm.user.ownerkey,
                                      callback: function($$v) {
                                        _vm.$set(_vm.user, "ownerkey", $$v)
                                      },
                                      expression: "user.ownerkey"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Phone",
                                    "label-for": _vm.getId("phone"),
                                    state: _vm.fieldState("phone"),
                                    "invalid-feedback": _vm.invalidField(
                                      "phone"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: _vm.getId("phone"),
                                      type: "text",
                                      state: _vm.fieldState("phone"),
                                      placeholder: "Enter phone number"
                                    },
                                    model: {
                                      value: _vm.user.profile.phone,
                                      callback: function($$v) {
                                        _vm.$set(_vm.user.profile, "phone", $$v)
                                      },
                                      expression: "user.profile.phone"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Fax",
                                    "label-for": _vm.getId("fax"),
                                    state: _vm.fieldState("fax"),
                                    "invalid-feedback": _vm.invalidField("fax")
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: _vm.getId("fax"),
                                      type: "text",
                                      state: _vm.fieldState("fax"),
                                      placeholder: "Enter fax"
                                    },
                                    model: {
                                      value: _vm.user.profile.fax,
                                      callback: function($$v) {
                                        _vm.$set(_vm.user.profile, "fax", $$v)
                                      },
                                      expression: "user.profile.fax"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Mobile",
                                    "label-for": _vm.getId("mobile"),
                                    state: _vm.fieldState("mobile"),
                                    "invalid-feedback": _vm.invalidField(
                                      "mobile"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: _vm.getId("mobile"),
                                      type: "text",
                                      state: _vm.fieldState("mobile"),
                                      placeholder: "Enter mobile"
                                    },
                                    model: {
                                      value: _vm.user.profile.mobile,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.user.profile,
                                          "mobile",
                                          $$v
                                        )
                                      },
                                      expression: "user.profile.mobile"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Address",
                                    "label-for": _vm.getId("address"),
                                    state: _vm.fieldState("address"),
                                    "invalid-feedback": _vm.invalidField(
                                      "address"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-textarea", {
                                    attrs: {
                                      id: _vm.getId("address"),
                                      type: "text",
                                      state: _vm.fieldState("address"),
                                      placeholder: "Enter address"
                                    },
                                    model: {
                                      value: _vm.user.profile.address,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.user.profile,
                                          "address",
                                          $$v
                                        )
                                      },
                                      expression: "user.profile.address"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "City",
                                    "label-for": _vm.getId("city"),
                                    state: _vm.fieldState("city"),
                                    "invalid-feedback": _vm.invalidField("city")
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: _vm.getId("city"),
                                      type: "text",
                                      state: _vm.fieldState("city"),
                                      placeholder: "Enter city"
                                    },
                                    model: {
                                      value: _vm.user.profile.city,
                                      callback: function($$v) {
                                        _vm.$set(_vm.user.profile, "city", $$v)
                                      },
                                      expression: "user.profile.city"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Post Code",
                                    "label-for": _vm.getId("post_code"),
                                    state: _vm.fieldState("post_code"),
                                    "invalid-feedback": _vm.invalidField(
                                      "post_code"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: _vm.getId("post_code"),
                                      type: "text",
                                      state: _vm.fieldState("post_code"),
                                      placeholder: "Enter post code"
                                    },
                                    model: {
                                      value: _vm.user.profile.post_code,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.user.profile,
                                          "post_code",
                                          $$v
                                        )
                                      },
                                      expression: "user.profile.post_code"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Country",
                                    "label-for": _vm.getId("country_id"),
                                    state: _vm.fieldState("country_id"),
                                    "invalid-feedback": _vm.invalidField(
                                      "country_id"
                                    )
                                  }
                                },
                                [
                                  _vm.$userIsAdmin()
                                    ? _c(
                                        "b-form-select",
                                        {
                                          staticClass: "form-control",
                                          attrs: {
                                            id: _vm.getId("country_id")
                                          },
                                          model: {
                                            value: _vm.user.country_id,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.user,
                                                "country_id",
                                                $$v
                                              )
                                            },
                                            expression: "user.country_id"
                                          }
                                        },
                                        _vm._l(_vm.countries, function(
                                          country
                                        ) {
                                          return _c(
                                            "option",
                                            { domProps: { value: country.id } },
                                            [_vm._v(_vm._s(country.name))]
                                          )
                                        }),
                                        0
                                      )
                                    : _vm.user.country && _vm.user.country.name
                                    ? [_vm._v(_vm._s(_vm.user.country.name))]
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Sales rep",
                                    "label-for": _vm.getId("sales_rep"),
                                    state: _vm.fieldState("sales_rep"),
                                    "invalid-feedback": _vm.invalidField(
                                      "sales_rep"
                                    )
                                  }
                                },
                                [
                                  _vm.$userIsAdmin()
                                    ? _c(
                                        "b-form-select",
                                        {
                                          staticClass: "form-control",
                                          attrs: {
                                            id: _vm.getId("sales_rep_id")
                                          },
                                          model: {
                                            value: _vm.user.sales_rep_id,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.user,
                                                "sales_rep_id",
                                                $$v
                                              )
                                            },
                                            expression: "user.sales_rep_id"
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: null } },
                                            [_vm._v("None")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(_vm.reps, function(user) {
                                            return _c(
                                              "option",
                                              { domProps: { value: user.id } },
                                              [_vm._v(_vm._s(user.name))]
                                            )
                                          })
                                        ],
                                        2
                                      )
                                    : _vm.user.sales_rep &&
                                      _vm.user.sales_rep.name
                                    ? [_vm._v(_vm._s(_vm.user.sales_rep.name))]
                                    : _vm._e()
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Customer Region",
                                    "label-for": _vm.getId("region_id"),
                                    state: _vm.fieldState("region_id"),
                                    "invalid-feedback": _vm.invalidField(
                                      "region_id"
                                    )
                                  }
                                },
                                [
                                  _vm.$userIsAdmin()
                                    ? _c(
                                        "b-form-select",
                                        {
                                          staticClass: "form-control",
                                          attrs: { id: _vm.getId("region_id") },
                                          model: {
                                            value: _vm.user.region_id,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.user,
                                                "region_id",
                                                $$v
                                              )
                                            },
                                            expression: "user.region_id"
                                          }
                                        },
                                        _vm._l(_vm.regions, function(region) {
                                          return _c(
                                            "option",
                                            { domProps: { value: region.id } },
                                            [_vm._v(_vm._s(region.name))]
                                          )
                                        }),
                                        0
                                      )
                                    : _vm.user.region && _vm.user.region.name
                                    ? [_vm._v(_vm._s(_vm.user.region.name))]
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Status",
                                    "label-for": _vm.getId("status_id"),
                                    state: _vm.fieldState("status_id"),
                                    "invalid-feedback": _vm.invalidField(
                                      "status_id"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      staticClass: "form-control",
                                      attrs: {
                                        disabled: !_vm.$userIsSuperAdmin(),
                                        id: _vm.getId("status_id")
                                      },
                                      model: {
                                        value: _vm.user.status_id,
                                        callback: function($$v) {
                                          _vm.$set(_vm.user, "status_id", $$v)
                                        },
                                        expression: "user.status_id"
                                      }
                                    },
                                    _vm._l(_vm.statuses, function(status) {
                                      return _c(
                                        "option",
                                        { domProps: { value: status.id } },
                                        [_vm._v(_vm._s(status.name))]
                                      )
                                    }),
                                    0
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.$userIsAdmin()
                                ? _c(
                                    "b-form-group",
                                    {
                                      staticClass: "col-md-6",
                                      attrs: {
                                        label: "Auction Type",
                                        "label-for": _vm.getId("auction_type"),
                                        state: _vm.fieldState("auction_type"),
                                        "invalid-feedback": _vm.invalidField(
                                          "auction_type"
                                        )
                                      }
                                    },
                                    [
                                      _c(
                                        "b-form-select",
                                        {
                                          staticClass: "form-control",
                                          attrs: {
                                            id: _vm.getId("auction_type")
                                          },
                                          model: {
                                            value: _vm.user.auction_type,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.user,
                                                "auction_type",
                                                $$v
                                              )
                                            },
                                            expression: "user.auction_type"
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: 1 } },
                                            [_vm._v("Default")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { domProps: { value: 2 } },
                                            [_vm._v("Specify")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.user.auction_type === 2 &&
                                      _vm.$userIsSuperAdmin()
                                        ? [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "#!" },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    _vm.showAuctionSiteModal = true
                                                  }
                                                }
                                              },
                                              [_vm._v("Specify auctions")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-modal",
                                              {
                                                attrs: {
                                                  id: "auction-sites-modal",
                                                  title: "Select auction sites"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "modal-footer",
                                                      fn: function(ref) {
                                                        var ok = ref.ok
                                                        var cancel = ref.cancel
                                                        var hide = ref.hide
                                                        return [
                                                          _c(
                                                            "b-button",
                                                            {
                                                              attrs: {
                                                                size: "sm",
                                                                variant:
                                                                  "danger"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.showAuctionSiteModal = false
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        Close\n                                                    "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  1831387715
                                                ),
                                                model: {
                                                  value:
                                                    _vm.showAuctionSiteModal,
                                                  callback: function($$v) {
                                                    _vm.showAuctionSiteModal = $$v
                                                  },
                                                  expression:
                                                    "showAuctionSiteModal"
                                                }
                                              },
                                              [
                                                _vm._v(" "),
                                                _c("auction-sites", {
                                                  attrs: { user: _vm.user }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Bid Color",
                                    "label-for": _vm.getId("profile.bid_color"),
                                    state: _vm.fieldState("profile.bid_color"),
                                    "invalid-feedback": _vm.invalidField(
                                      "profile.bid_color"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    staticClass: "input-color",
                                    attrs: {
                                      id: _vm.getId("bid_color"),
                                      type: "color",
                                      state: _vm.fieldState(
                                        "profile.bid_color"
                                      ),
                                      value: "#fff",
                                      placeholder: ""
                                    },
                                    model: {
                                      value: _vm.user.profile.bid_color,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.user.profile,
                                          "bid_color",
                                          $$v
                                        )
                                      },
                                      expression: "user.profile.bid_color"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.$userIsSuperAdmin() && _vm.user.role_id !== 2
                                ? _c(
                                    "b-form-group",
                                    {
                                      staticClass: "col-md-6",
                                      attrs: {
                                        label: "Nichibo User",
                                        "label-for": _vm.getId("nichibo_user"),
                                        state: _vm.fieldState("nichibo_user"),
                                        "invalid-feedback": _vm.invalidField(
                                          "nichibo_user"
                                        )
                                      }
                                    },
                                    [
                                      _c(
                                        "b-form-select",
                                        {
                                          staticClass: "form-control",
                                          attrs: {
                                            id: _vm.getId("nichibo_user")
                                          },
                                          model: {
                                            value: _vm.user.nichibo_user,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.user,
                                                "nichibo_user",
                                                $$v
                                              )
                                            },
                                            expression: "user.nichibo_user"
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: null } },
                                            [_vm._v("None")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-CLIENT" } },
                                            [_vm._v("SBL-CLIENT")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-SIMON" } },
                                            [_vm._v("SBL-SIMON")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-GLENN" } },
                                            [_vm._v("SBL-GLENN")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-JAMES" } },
                                            [_vm._v("SBL-JAMES")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-MARC" } },
                                            [_vm._v("SBL-MARC")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-HIROMI" } },
                                            [_vm._v("SBL-HIROMI")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: { value: "SBL-MITCHELL" }
                                            },
                                            [_vm._v("SBL-MITCHELL")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-VUKAN" } },
                                            [_vm._v("SBL-VUKAN")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-JASON" } },
                                            [_vm._v("SBL-JASON")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-SHANE" } },
                                            [_vm._v("SBL-SHANE")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-TEST" } },
                                            [_vm._v("SBL-TEST")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Global (on behalf)",
                                    "label-for": _vm.getId(
                                      "profile.global_list_colour"
                                    ),
                                    state: _vm.fieldState(
                                      "profile.global_list_colour"
                                    ),
                                    "invalid-feedback": _vm.invalidField(
                                      "profile.global_list_colour"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    staticClass: "input-color",
                                    attrs: {
                                      id: _vm.getId("global_list_colour"),
                                      type: "color",
                                      state: _vm.fieldState(
                                        "profile.global_list_colour"
                                      ),
                                      placeholder: ""
                                    },
                                    model: {
                                      value:
                                        _vm.user.profile.global_list_colour,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.user.profile,
                                          "global_list_colour",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "user.profile.global_list_colour"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Bid Initials",
                                    "label-for": _vm.getId("bid_initials"),
                                    state: _vm.fieldState("bid_initials"),
                                    "invalid-feedback": _vm.invalidField(
                                      "bid_initials"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      disabled: !_vm.$userIsSuperAdmin(),
                                      id: _vm.getId("bid_initials"),
                                      type: "text",
                                      state: _vm.fieldState("bid_initials"),
                                      placeholder:
                                        "Bid Initials sent with the bid"
                                    },
                                    model: {
                                      value: _vm.user.bid_initials,
                                      callback: function($$v) {
                                        _vm.$set(_vm.user, "bid_initials", $$v)
                                      },
                                      expression: "user.bid_initials"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.$userIsAdmin() && _vm.user.role_id !== 2
                                ? _c(
                                    "b-form-group",
                                    {
                                      staticClass: "col-md-6",
                                      attrs: {
                                        label: "Nichibo Dealers User",
                                        title:
                                          "The nichibo user that this reps dealers will use",
                                        "label-for": _vm.getId(
                                          "nichibo_dealers_user"
                                        ),
                                        state: _vm.fieldState(
                                          "nichibo_dealers_user"
                                        ),
                                        "invalid-feedback": _vm.invalidField(
                                          "nichibo_dealers_user"
                                        )
                                      }
                                    },
                                    [
                                      _c(
                                        "b-form-select",
                                        {
                                          staticClass: "form-control",
                                          attrs: {
                                            id: _vm.getId(
                                              "nichibo_dealers_user"
                                            )
                                          },
                                          model: {
                                            value:
                                              _vm.user.nichibo_dealers_user,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.user,
                                                "nichibo_dealers_user",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "user.nichibo_dealers_user"
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: null } },
                                            [_vm._v("None")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-CLIENT" } },
                                            [_vm._v("SBL-CLIENT")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-SIMON" } },
                                            [_vm._v("SBL-SIMON")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-GLENN" } },
                                            [_vm._v("SBL-GLENN")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-JAMES" } },
                                            [_vm._v("SBL-JAMES")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-MARC" } },
                                            [_vm._v("SBL-MARC")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-HIROMI" } },
                                            [_vm._v("SBL-HIROMI")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: { value: "SBL-MITCHELL" }
                                            },
                                            [_vm._v("SBL-MITCHELL")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-VUKAN" } },
                                            [_vm._v("SBL-VUKAN")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-JASON" } },
                                            [_vm._v("SBL-JASON")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-SHANE" } },
                                            [_vm._v("SBL-SHANE")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "SBL-TEST" } },
                                            [_vm._v("SBL-TEST")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _vm.user.role_id !== 2
                                ? _c(
                                    "b-form-group",
                                    {
                                      staticClass: "col-md-6",
                                      attrs: {
                                        label: "Unsold Days",
                                        "label-for": _vm.getId("unsold_days"),
                                        state: _vm.fieldState("unsold_days"),
                                        "invalid-feedback": _vm.invalidField(
                                          "unsold_days"
                                        )
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          disabled: !_vm.$userIsSuperAdmin(),
                                          id: _vm.getId("unsold_days"),
                                          type: "number",
                                          state: _vm.fieldState("unsold_days"),
                                          placeholder:
                                            "The number of days for  cars to move from unsold to public"
                                        },
                                        model: {
                                          value: _vm.user.unsold_days,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.user,
                                              "unsold_days",
                                              $$v
                                            )
                                          },
                                          expression: "user.unsold_days"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "User Role",
                                    "label-for": _vm.getId("role_id"),
                                    state: _vm.fieldState("role_id"),
                                    "invalid-feedback": _vm.invalidField(
                                      "role_id"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      staticClass: "form-control",
                                      attrs: {
                                        disabled: !_vm.$userIsSuperAdmin(),
                                        id: _vm.getId("role_id")
                                      },
                                      model: {
                                        value: _vm.user.role_id,
                                        callback: function($$v) {
                                          _vm.$set(_vm.user, "role_id", $$v)
                                        },
                                        expression: "user.role_id"
                                      }
                                    },
                                    _vm._l(_vm.user_roles, function(role) {
                                      return _c(
                                        "option",
                                        { domProps: { value: role.id } },
                                        [_vm._v(_vm._s(role.name))]
                                      )
                                    }),
                                    0
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "SBL User id (required for bidding)",
                                    "label-for": _vm.getId("sbl_id"),
                                    state: _vm.fieldState("sbl_id"),
                                    "invalid-feedback": _vm.invalidField(
                                      "sbl_id"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      disabled: !_vm.$userIsSuperAdmin(),
                                      id: _vm.getId("sbl_id"),
                                      type: "number",
                                      state: _vm.fieldState("sbl_id"),
                                      placeholder:
                                        "user ID from old system (in the url on the edit page)"
                                    },
                                    model: {
                                      value: _vm.user.sbl_id,
                                      callback: function($$v) {
                                        _vm.$set(_vm.user, "sbl_id", $$v)
                                      },
                                      expression: "user.sbl_id"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Password",
                                    "label-for": _vm.getId("password"),
                                    state: _vm.fieldState("password"),
                                    "invalid-feedback": _vm.invalidField(
                                      "password"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: _vm.getId("password"),
                                      type: "password",
                                      autocomplete: "new-password",
                                      readonly: _vm.ro_fields["password"],
                                      state: _vm.fieldState("password"),
                                      placeholder: "Enter password"
                                    },
                                    on: {
                                      focus: function($event) {
                                        return _vm.setReadOnly(
                                          "password",
                                          false
                                        )
                                      },
                                      blur: function($event) {
                                        return _vm.setReadOnly("password", true)
                                      }
                                    },
                                    model: {
                                      value: _vm.user.password,
                                      callback: function($$v) {
                                        _vm.$set(_vm.user, "password", $$v)
                                      },
                                      expression: "user.password"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "col-md-6",
                                  attrs: {
                                    label: "Confirm password",
                                    "label-for": _vm.getId("confirm_password"),
                                    state: _vm.fieldState("confirm_password"),
                                    "invalid-feedback": _vm.invalidField(
                                      "confirm_password"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: _vm.getId("confirm_password"),
                                      type: "password",
                                      readonly:
                                        _vm.ro_fields["password_confirmation"],
                                      state: _vm.fieldState("confirm_password"),
                                      placeholder: "Enter confirm password"
                                    },
                                    on: {
                                      focus: function($event) {
                                        return _vm.setReadOnly(
                                          "password_confirmation",
                                          false
                                        )
                                      },
                                      blur: function($event) {
                                        return _vm.setReadOnly(
                                          "password_confirmation",
                                          true
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.user.confirm_password,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.user,
                                          "confirm_password",
                                          $$v
                                        )
                                      },
                                      expression: "user.confirm_password"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.$userIsAdmin()
                            ? _c(
                                "div",
                                { staticClass: "form-row" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "col-md-12",
                                      attrs: {
                                        label: "Note",
                                        "label-for": _vm.getId("profile.note"),
                                        state: _vm.fieldState("profile.note"),
                                        "invalid-feedback": _vm.invalidField(
                                          "profile.note"
                                        )
                                      }
                                    },
                                    [
                                      _c("b-form-textarea", {
                                        attrs: {
                                          rows: 6,
                                          id: _vm.getId("profile.note")
                                        },
                                        model: {
                                          value: _vm.user.profile.note,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.user.profile,
                                              "note",
                                              $$v
                                            )
                                          },
                                          expression: "user.profile.note"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-row" },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "col-md-6",
                                attrs: {
                                  label: "Shared Sales Rep",
                                  "label-for": _vm.getId("shared_sales_rep"),
                                  state: _vm.fieldState("shared_sales_rep"),
                                  "invalid-feedback": _vm.invalidField(
                                    "shared_sales_rep"
                                  )
                                }
                              },
                              [
                                _vm.$userIsSuperAdmin()
                                  ? [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass:
                                            "shared-sales-rep-select",
                                          attrs: {
                                            multiple: "",
                                            placeholder: "-",
                                            "filter-by-shared-sales-reps": true
                                          },
                                          on: {
                                            change:
                                              _vm.handleSharedSalesRepChange
                                          },
                                          model: {
                                            value: _vm.user.shared_sales_rep,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.user,
                                                "shared_sales_rep",
                                                $$v
                                              )
                                            },
                                            expression: "user.shared_sales_rep"
                                          }
                                        },
                                        _vm._l(_vm.sharedSalesReps, function(
                                          rep
                                        ) {
                                          return _c("el-option", {
                                            key: rep.id,
                                            attrs: {
                                              label: rep.name,
                                              value: rep.id
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ]
                                  : [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "shared-sales-rep-display"
                                        },
                                        [
                                          _vm.user.shared_sales_rep &&
                                          _vm.user.shared_sales_rep.length
                                            ? [
                                                _vm._v(
                                                  "\n                                                " +
                                                    _vm._s(
                                                      _vm.user.shared_sales_rep
                                                        .map(function(repId) {
                                                          return _vm.getRepName(
                                                            repId
                                                          )
                                                        })
                                                        .join(", ")
                                                    ) +
                                                    "\n                                            "
                                                )
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                                                -\n                                            "
                                                )
                                              ]
                                        ],
                                        2
                                      )
                                    ]
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("b-form-group", { staticClass: "col-md-6" }, [
                              _c("h3", [
                                _vm._v("leave blank to see sales rep stock")
                              ])
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.$userIsSuperAdmin()
                          ? [
                              _vm.$userIsSuperAdmin()
                                ? _c("inspection-emails", {
                                    on: {
                                      "inspection-email-deleted":
                                        _vm.addDeletedInspectionEmailId
                                    },
                                    model: {
                                      value: _vm.user.inspection_emails,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.user,
                                          "inspection_emails",
                                          $$v
                                        )
                                      },
                                      expression: "user.inspection_emails"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-row user-block" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "aria-describedby":
                                          "pricing_rule_validate_feedback",
                                        state: _vm.fieldState("pricing_rule")
                                      }
                                    },
                                    [
                                      _vm.user.region
                                        ? _c("h3", [
                                            _vm._v(
                                              "Please note the fees are in " +
                                                _vm._s(
                                                  _vm.user.region.currency_code
                                                )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("fees", {
                                        attrs: { user: _vm.user },
                                        model: {
                                          value: _vm.user.pricing_rule,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.user,
                                              "pricing_rule",
                                              $$v
                                            )
                                          },
                                          expression: "user.pricing_rule"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            slot: "invalid-feedback",
                                            id: "pricing_rule_validate_feedback"
                                          },
                                          slot: "invalid-feedback"
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.invalidField("pricing_rule")
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$userIsAdmin()
                          ? [
                              _c(
                                "div",
                                { staticClass: "form-row user-block" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "aria-describedby":
                                          "bump_bid_validate_feedback",
                                        state: _vm.fieldState("pricing_rule")
                                      }
                                    },
                                    [
                                      _c("bumpBids", {
                                        model: {
                                          value: _vm.user.bump_bid,
                                          callback: function($$v) {
                                            _vm.$set(_vm.user, "bump_bid", $$v)
                                          },
                                          expression: "user.bump_bid"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            slot: "invalid-feedback",
                                            id: "bump_bid_validate_feedback"
                                          },
                                          slot: "invalid-feedback"
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.invalidField("bump_bid")
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-row user-block" },
                          [
                            _vm.$userIsAdmin()
                              ? _c(
                                  "b-form-group",
                                  {
                                    staticClass: "col-md-6",
                                    attrs: {
                                      label: "Inactive date",
                                      "label-for": _vm.getId("date_block"),
                                      state: _vm.fieldState("date_block"),
                                      "invalid-feedback": _vm.invalidField(
                                        "date_block"
                                      )
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: _vm.getId("date_block"),
                                        type: "date",
                                        state: _vm.fieldState("date_block"),
                                        placeholder: "Enter inactive date"
                                      },
                                      model: {
                                        value: _vm.blockDate,
                                        callback: function($$v) {
                                          _vm.blockDate = $$v
                                        },
                                        expression: "blockDate"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$userIsAdmin()
                              ? _c(
                                  "b-form-group",
                                  {
                                    staticClass: "col-md-6",
                                    attrs: {
                                      label: "Preview_date",
                                      "label-for": _vm.getId("date_preview"),
                                      state: _vm.fieldState("date_preview"),
                                      "invalid-feedback": _vm.invalidField(
                                        "date_preview"
                                      )
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: _vm.getId("date_preview"),
                                        type: "date",
                                        state: _vm.fieldState("date_preview"),
                                        placeholder: "Enter preview date"
                                      },
                                      model: {
                                        value: _vm.previewDate,
                                        callback: function($$v) {
                                          _vm.previewDate = $$v
                                        },
                                        expression: "previewDate"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.$userIsAdmin()
                          ? _c(
                              "div",
                              { staticClass: "form-row user-block" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    key: "enable_signature",
                                    staticClass: "col-md-12 vue-checkbox",
                                    attrs: {
                                      "label-for": _vm.getId(
                                        "enable_signature"
                                      ),
                                      state: _vm.fieldState(
                                        "privileges.enable_signature"
                                      ),
                                      "invalid-feedback": _vm.invalidField(
                                        "privileges.enable_signature"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        attrs: {
                                          value: 1,
                                          id: _vm.getId("enable_signature"),
                                          state: _vm.fieldState(
                                            "privileges.enable_signature"
                                          )
                                        },
                                        model: {
                                          value:
                                            _vm.user.privileges
                                              .enable_signature,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.user.privileges,
                                              "enable_signature",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "user.privileges.enable_signature"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        Enable Email Signature\n                                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.user.privileges.enable_signature
                                  ? _c(
                                      "div",
                                      { staticClass: "col-md-12" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "btn-link",
                                            attrs: { href: "#!" },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.resetDefaultSignature.apply(
                                                  null,
                                                  arguments
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        Reset to default\n                                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("editor", {
                                          attrs: {
                                            "api-key": _vm.TINYMCE_API_KEY,
                                            init: _vm.editor_settings
                                          },
                                          model: {
                                            value: _vm.user.signature,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.user,
                                                "signature",
                                                $$v
                                              )
                                            },
                                            expression: "user.signature"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c(
                            "div",
                            { staticClass: "form-group col-md-6" },
                            [
                              _c(
                                "b-btn",
                                {
                                  staticClass: "btn",
                                  attrs: { type: "submit" }
                                },
                                [_vm._v("Save")]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "user-block" },
                        _vm._l(_vm.privileges, function(priv_data, priv_name) {
                          return _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("h4", [_vm._v(_vm._s(priv_name))])
                              ]),
                              _vm._v(" "),
                              _vm.$userIsSuperAdmin()
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "user-full-access col-md-12"
                                    },
                                    [
                                      priv_name === "Bidding"
                                        ? [
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: {
                                                  value: true,
                                                  "unchecked-value": false
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.setPrivileges(
                                                      priv_name
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: _vm.biddingFullAccess,
                                                  callback: function($$v) {
                                                    _vm.biddingFullAccess = $$v
                                                  },
                                                  expression:
                                                    "biddingFullAccess"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                Full access\n                                            "
                                                )
                                              ]
                                            )
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      priv_name === "Vehicle Info"
                                        ? [
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: {
                                                  value: true,
                                                  "unchecked-value": false
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.setPrivileges(
                                                      priv_name
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: _vm.vehicleFullAccess,
                                                  callback: function($$v) {
                                                    _vm.vehicleFullAccess = $$v
                                                  },
                                                  expression:
                                                    "vehicleFullAccess"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                Full access\n                                            "
                                                )
                                              ]
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(priv_data, function(label, key) {
                                return [
                                  _vm.$userIsSuperAdmin()
                                    ? _c(
                                        "b-form-group",
                                        {
                                          key: key,
                                          staticClass: "col-md-12 vue-checkbox",
                                          attrs: {
                                            label: label,
                                            "label-for": _vm.getId(key),
                                            state: _vm.fieldState(
                                              "privileges." + key
                                            ),
                                            "invalid-feedback": _vm.invalidField(
                                              "privileges." + key
                                            )
                                          }
                                        },
                                        [
                                          _c("b-form-checkbox", {
                                            attrs: {
                                              value: 1,
                                              id: _vm.getId(key),
                                              state: _vm.fieldState(
                                                "privileges" + key
                                              )
                                            },
                                            model: {
                                              value: _vm.user.privileges[key],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.user.privileges,
                                                  key,
                                                  $$v
                                                )
                                              },
                                              expression: "user.privileges[key]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "privilege col-md-12" },
                                        [
                                          _vm._v(
                                            _vm._s(label) +
                                              " -\n                                            "
                                          ),
                                          _vm.user.privileges[key]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-success" },
                                                [_vm._v("Yes")]
                                              )
                                            : _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [_vm._v("No")]
                                              )
                                        ]
                                      )
                                ]
                              })
                            ],
                            2
                          )
                        }),
                        0
                      )
                    ])
                  ])
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("h2", [
        _vm._v(
          "\n                            Edit User\n                        "
        )
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f2f0a404", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2f0a404","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/User/EditUser.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-f2f0a404","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/User/EditUser.vue
// module chunks = 0